import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <span>&copy; {new Date().getFullYear()} Jared Franzone</span>
      <span className="footer-dot">&middot;</span>
      <span>Seattle, WA</span>
    </footer>
  );
};

export default Footer;
